import React from 'react'

import { SeparatorContainer } from './styles'

interface TSeparator {
  mb?: number
  mt?: number
}

export function Separator({ mb, mt }: TSeparator) {
  return <SeparatorContainer $mb={mb} $mt={mt} />
}
